import { Chip } from '@mui/material';
import type { ChipProps } from '@mui/material';

type StatusChipProps = Omit<ChipProps, 'color'> & {
  status?: 'pending' | 'approved' | 'rejected' | 'played' | 'active' | 'closed' | 'draft' | 'archived' | 'cancelled';
};

const statusColorMap: Record<string, ChipProps['color']> = {
  pending: 'warning',
  approved: 'success',
  rejected: 'error',
  played: 'primary',
  active: 'success',
  closed: 'warning',
  draft: 'default',
  archived: 'default',
  cancelled: 'default',
};

export function StatusChip({ status = 'draft', ...props }: StatusChipProps) {
  return (
    <Chip
      {...props}
      color={statusColorMap[status]}
      sx={{
        fontWeight: 700,
        ...props.sx,
      }}
    />
  );
}
